import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderMethod, useOrderLocation } from '@/hooks/api/order';

const { classNames } = Mobi2Go.helpers;
const { Order, UI } = Mobi2Go;

const CurbsidePickupButton = () => {
    const [t] = useTranslation('order.curbside-pickup');
    const location = useOrderLocation();
    const selectedMethod = useOrderMethod();
    const [isCurbsidePickupOrder, setCurbsidePickupOrder] = useState(false);

    const onCurbsideDetailsClick = () => {
        UI.trigger('showCurbsidePickupModal');
    }

    useEffect(() => {
        Order.setIsCurbsidePickupOrder(isCurbsidePickupOrder);
    }, [isCurbsidePickupOrder])

    return location?.curbside_pickup_enabled && selectedMethod === 'pickup' ? (
        <div className="m2g-order-curbside-pickup">
            <div
                role="checkbox"
                tabIndex={0}
                data-subscriber
                data-checked={isCurbsidePickupOrder}
                aria-checked={isCurbsidePickupOrder}
                className="m2g-list-cell m2g-touchable"
                onClick={() => setCurbsidePickupOrder(!isCurbsidePickupOrder)}
                onKeyUp={e => {
                    if (e.key !== ' ') {
                        return;
                    }
                    setCurbsidePickupOrder(!isCurbsidePickupOrder);
                }}
            >
                <div className="m2g-list-cell__content">
                    <span className="m2g-icon m2g-icon--checkbox m2g-icon--tick" />
                    <label className="m2g-customer-subscriber-label">
                        {t("header")}
                    </label>
                </div>
            </div>

            {isCurbsidePickupOrder ? (
                <button
                    data-checkout
                    className={classNames(
                        'm2g-button',
                        'm2g-button--primary',
                        'm2g-button--fat',
                        'm2g-form-element--full-width',
                    )}
                    style={{ marginTop: '10px' }}
                    type="button"
                    onClick={onCurbsideDetailsClick}
                >
                    {t("car_details")}
                </button>
            ) : null}
        </div>
    ) : null;
};

export default CurbsidePickupButton;
